import produce from "immer"
import { ASC } from "const"
import { CcRequirementSmartCompliance } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcRequirementSmartCompliance: CcRequirementSmartCompliance = {
    id: null,
    accountId: null,
    projectId: null,
    name: "",
    description: "",
    creator: null,
    default: false,
}

const initCcRequirementSmartComplianceState: types.CcRequirementSmartComplianceState = {
    complianceList: {},
    complianceIds: [],
    complianceEdit: initCcRequirementSmartCompliance,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const ccRequirementSmartComplianceReducer = produce((
    draft: types.CcRequirementSmartComplianceState = initCcRequirementSmartComplianceState,
    action: ActionTypes = null,
): types.CcRequirementSmartComplianceState => {
    switch (action.type) {
        case types.CC_REQUIREMENT_SMART_COMPLIANCE_LIST:
            draft.complianceList = action.complianceList
            return draft

        case types.CC_REQUIREMENT_SMART_COMPLIANCE_IDS:
            draft.complianceIds = action.complianceIds
            return draft

        case types.CC_REQUIREMENT_SMART_COMPLIANCE_EDIT:
            draft.complianceEdit = action.compliance
            return draft

        case types.CC_REQUIREMENT_SMART_COMPLIANCE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.CC_REQUIREMENT_SMART_COMPLIANCE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.CC_REQUIREMENT_SMART_COMPLIANCE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_REQUIREMENT_SMART_COMPLIANCE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default ccRequirementSmartComplianceReducer
